/*
 * POYTER — carousel enhancer (shared)
 * Progressive enhancement over native scroll-snap: prev/next arrows that scroll
 * one card at a time and disable themselves at the ends. Native touch scroll is
 * untouched. Scoped to [data-carousel] roots; re-inits on Theme Editor load.
 */
(function () {
  'use strict';

  function initCarousel(root) {
    if (!root || root.dataset.pytCarouselInit) return;
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track || !prev || !next) return;
    root.dataset.pytCarouselInit = '1';

    function stepSize() {
      var first = track.firstElementChild;
      if (!first) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || parseFloat(getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2 || max <= 0;
      next.disabled = track.scrollLeft >= max || max <= 0;
      // Hide the whole control when there is nothing to scroll (all cards fit).
      var nav = prev.parentElement;
      if (nav) nav.style.visibility = max <= 0 ? 'hidden' : '';
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -stepSize(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: stepSize(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();
  }

  function initAll(scope) {
    var roots = (scope || document).querySelectorAll('[data-carousel]');
    Array.prototype.forEach.call(roots, initCarousel);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector ? e.target.querySelector('[data-carousel]') : null;
    if (root) { root.removeAttribute('data-pyt-carousel-init'); initCarousel(root); }
  });
})();
